import alt from '../alt';
import LPClient from '../lp_client';

class LPListingsActions {
  lpListingsLoaded(listings) {
    return listings;
  }

  loadListings(ids) {
    return LPClient.fetchListings(ids).then((response) => {
      this.lpListingsLoaded(response.listings);
    }).catch((err) => {
      throw err;
    });
  }
}

export default alt.createActions(LPListingsActions);



// WEBPACK FOOTER //
// ./javascripts/components/lp_listings/lp_listings_actions.js